import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFamilyId } from '../contexts/FamilyIdContext';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * FamilyRoute - Ensures user has a family before accessing pages
 * Redirects to /family-setup if no family is found
 */
function FamilyRoute({ children }) {
  const { familyId, loading } = useFamilyId();

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="primary">
          Loading your family...
        </Typography>
      </Box>
    );
  }

  // If no family, redirect to family setup
  if (!familyId) {
    return <Navigate to="/family-setup" replace />;
  }

  // Has family, render the protected content
  return children;
}

export default FamilyRoute;













